export default __webpack_public_path__ + "static/media/element_48.0457f6b1.webp";